// extracted by mini-css-extract-plugin
export default {"container":"x2QPz","button":"LZmBz","slider":"xSRBI","steps":"ZdubA","input":"qzrNw"};